import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { ACCESS_TOKEN_KEY_NAME } from "@nju/scope";
import { CURRENT_ACTIVE_CLIENT_EMAIL } from "../consts";
import { IRegisterResult } from "./types";
import { serverResponse } from "./validators";

interface IRegisterParams {
  email: string;
}

export async function register({
  email,
}: IRegisterParams): Promise<IRegisterResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users`,
    {
      method: "post",
      validator: serverResponse,
      scope: "sales",
      headers: {
        "Accept-Language": "en",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID_SALES,
        "Origin-channel": "Public",
        "x-source": "fw",
      },
      json: {
        email,
        type: "NJU_CUSTOMER",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);

    return result;
  }

  window.localStorage.setItem(ACCESS_TOKEN_KEY_NAME, result.value.access_token);
  window.localStorage.setItem(CURRENT_ACTIVE_CLIENT_EMAIL, email);

  return ok({
    access_token: result.value.access_token,
  });
}
